import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import ChatThread from './ChatThread';

/**
 * Chat zu einer konkreten Anfrage. Bewusst als Dialog: der Chat gehoert zur
 * Anfrage und nicht auf eine eigene Route.
 */
const ChatDialog = ({ request, open, onOpenChange, title, subtitle, onActivity }) => {
  if (!request) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl h-[80vh] p-0 gap-0 flex flex-col overflow-hidden">
        <DialogHeader className="px-5 py-4 border-b border-gray-200 flex-shrink-0">
          <DialogTitle className="text-lg font-bold text-[#2B2142]">{title}</DialogTitle>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </DialogHeader>
        <div className="flex-1 min-h-0">
          <ChatThread requestId={request.id} onActivity={onActivity} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChatDialog;
